import { render, staticRenderFns } from "./ReferralDetailModal.vue?vue&type=template&id=b85a8710&scoped=true"
import script from "./ReferralDetailModal.vue?vue&type=script&lang=js"
export * from "./ReferralDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralDetailModal.vue?vue&type=style&index=0&id=b85a8710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85a8710",
  null
  
)

export default component.exports